__turbopack_context__.v({
  "loading": "model-application-form-module-scss-module__rMnZuG__loading",
  "overlay": "model-application-form-module-scss-module__rMnZuG__overlay",
});
